export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE"
